import axios from "./config";

const SCHEMA = "/lookup";

export function GetAllPCs() {
  return axios.get(`${SCHEMA}/portfolio-companies`);
}
